import { Box, Heading, Text, CheckCircle2Icon } from '@razorpay/blade/components';
import xGrey from 'assets/mss/x-grey.svg';
import React from 'react';

const features = [
  'Create structures in seconds',
  'Create structures by department, roles etc.',
  'Live preview with actual CTC calculations',
  'Align salary with business policies',
  'Easily manage salary revisions & promotions',
];

export const SalaryStructureIntroInformation = () => {
  return (
    <Box
      padding="spacing.7"
      borderRadius="large"
      borderWidth={'thin'}
      borderColor="surface.border.gray.muted"
      backgroundImage={`url("${xGrey}")`}
      backgroundRepeat="no-repeat"
      backgroundPosition="right bottom"
      height="100%"
      overflow="auto">
      <Box padding="spacing.6" display={'flex'} flexDirection="column" gap="spacing.8">
        <Box width={'70%'}>
          <Heading weight="medium" size="large">
            Powerful Salary Structuring Made Easy🔥
          </Heading>
        </Box>

        <Box display="flex" flexDirection="column" gap="spacing.7">
          {features.map((feature, index) => (
            <Box key={feature} display="flex" alignItems="center" gap="spacing.4">
              <CheckCircle2Icon color="feedback.icon.positive.intense" size="large" />
              <Text size="large" color="surface.text.gray.subtle">
                {feature}
              </Text>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
